var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 100,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_184_6357"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "svg_1",
    x: 0.28027,
    y: 0,
    fill: "white",
    height: 139,
    width: 139.458
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 -19)",
    clipPath: "url(#clip0_184_6357)"
  }, /*#__PURE__*/React.createElement("mask", {
    height: 102,
    width: 171,
    y: 18,
    x: -20,
    maskUnits: "userSpaceOnUse",
    id: "mask0_184_6357"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#29CC9A",
    strokeOpacity: 0.5,
    fillOpacity: 0.5,
    fill: "#29CC9A",
    d: "m-19.1426,27.3422c0,-4.4061 3.5719,-7.9779 7.978,-7.9779l153.3816,0c4.406,0 7.978,3.5718 7.978,7.9779l0,83.3228c0,4.406 -3.572,7.978 -7.978,7.978l-153.3816,0c-4.4061,0 -7.978,-3.572 -7.978,-7.978l0,-83.3228z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_184_6357)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#29CC9A",
    d: "m139.738,69.5c0,38.386 -31.221,69.5 -69.7288,69.5c-38.5082,0 -69.72893,-31.114 -69.72893,-69.5c0,-38.3859 31.22073,-69.5 69.72893,-69.5c38.5078,0 69.7288,31.1182 69.7288,69.5zm-73.468,27.4906l43.202,-43.0559c3.357,-3.3464 3.357,-8.7733 0,-12.1238c-3.357,-3.3464 -8.802,-3.3464 -12.1597,0l-37.3213,37.1987l-17.2766,-17.2199c-3.3574,-3.3463 -8.8022,-3.3463 -12.1596,0c-3.3574,3.3464 -3.3574,8.7734 0,12.1239l23.1531,23.077c1.7305,1.7249 4.0089,2.5894 6.2831,2.5894c2.2743,0 4.5526,-0.8645 6.2832,-2.5894l-0.0042,0z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.ec60af5ff993fe8515e9dd6cc2f996a4.svg";
export { ForwardRef as ReactComponent };